export default [
  {
    name: 'College of Arts & Sciences (Undergraduate)',
    lastName: [{
      value: 'A-L',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-casathrul-students',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-casmthruz-students',
    },
    {
      value: 'M-Z',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-casmthruz-students',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-cas-last-names-l-z',
    }],
  },
  {
    name: 'College of Fine Arts (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-cfa-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-cfa-students',
  },
  {
    name: 'College of Fine Arts (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-cfa-undergrad-stud-clone',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-cfa-undergrad-stude-clone',
  },
  {
    name: 'College of General Studies',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-cgs-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-cgs-students',
  },
  {
    name: 'College of Communication (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-com-grad-students-clone',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-com-undergrad-stude-clone',
  },
  {
    name: 'College of Communication (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-com-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-com-students',
  },
  {
    name: 'College of Engineering (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-eng-ug-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-eng-ug-students',
  },
  {
    name: 'College of Engineering (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-eng-grad-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-eng-grad-students',
  },
  {
    name: 'Bioinformatics',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-egs-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-egs-students',
  },
  {
    name: 'Faculty of Computing & Data Sciences (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-cds-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-cds-students',
  },
  {
    name: 'Faculty of Computing & Data Sciences (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-cds-undergrad-stud-clone',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-cds-undergrad-stude-clone',
  },
  {
    name: 'College of Arts & Sciences (Graduate)',
    lastName: [{
      value: 'A-L',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-grs-students',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-grs-students',
    },
    {
      value: 'M-Z',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-grs-students-a-clone',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-grs-students-a-l-clone',
    }],
  },
  {
    name: 'School of Law',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-law-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-law-students',
  },
  {
    name: 'School of Medicine',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-med-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-med-students',
  },
  {
    name: 'Metropolitan College',
    lastName: [{
      value: 'A-I',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-metathrul-students',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-metathrul-students',
    },
    {
      value: 'J-R',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-met-last-name-a-l-clone',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-met-last-name-s-z-clone',
    },
    {
      value: 'S-Z',
      '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-metmthruz-students',
      '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-metmthruz-students',
    }],
  },
  {
    name: 'Questrom School of Business (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15min-advising-appointment-for-qst-ug-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/advising-appt-30-minutes-for-qst-undergrad-student',
  },
  {
    name: 'Questrom School of Business (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-qst-grad-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-qst-grad-students',
  },
  {
    name: 'Sargent College of Health & Rehabilitation Sciences (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sar-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sar-students',
  },
  {
    name: 'Sargent College of Health & Rehabilitation Sciences (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sar-undergrad-stud-clone',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sar-undergrad-stude-clone',
  },
  {
    name: 'Wheelock College of Education & Human Development (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sed-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sed-students',
  },
  {
    name: 'Wheelock College of Education & Human Development (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sed-undergrad-stud-clone',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sed-undergrad-stude-clone',
  },
  {
    name: 'Goldman School of Dental Medicine',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sdm-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sdm-students',
  },
  {
    name: 'School of Hospitality (Undergraduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sha-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minutes-advising-appt-for-sha-students-clone',
  },
  {
    name: 'School of Hospitality (Graduate)',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sha-students-clone',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minutes-advising-appt-for-sha-students-clone-1',
  },
  {
    name: 'School of Public Health',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sph-a-z',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sph-a-z',
  },
  {
    name: 'School of Social Work',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-ssw-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-ssw-students',
  },
  {
    name: 'School of Theology',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-sth-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-sth-students',
  },
  /*
  {
    name: 'Summer Term',
    '15-minute': '',
    '30-minute': '',
    OPT: '',
    'STEM OPT': ''
  },
  */
  {
    name: 'Non-Degree Exchange students',
    '15-minute': 'https://calendly.com/bu-isso-student-advising/15-minutes-advising-appt-for-xrg-students',
    '30-minute': 'https://calendly.com/bu-isso-student-advising/30-minute-advising-appt-for-xrg-students',
  },
];
